// this file is generated by update_shopify_store_data.py at 2026-11-02 20:12:10.027825
var courses = [
    {
        "course_id": "E365BC1C-6500-EC11-80E5-005056B16B79",
        "course_version": 2,
        "name": "S.T.A.B.L.E. \u2013 Physical and Gestational Age Assessment of the Newborn, 3rd Ed. \u2013 Online Slides",
        "course_type": 1,
        "author_information": "Kristine A. Karlsen, PhD, NNP-BC, FAAN, Neonatal Nurse Practitioner, S.T.A.B.L.E. Program Author and Founder, and S.T.A.B.L.E. Program Director.",
        "description": "388 beautiful slides to help learn how to do a gestational age assessment and a thorough physical exam of the newborn.\r\nThis PowerPoint slide show supplements the S.T.A.B.L.E. Program Learner course or can be used as a stand-alone self-study or instructor-led presentation for pediatric, obstetric, and family practice residents, neonatal and obstetric nurses, respiratory therapists and other healthcare providers involved with neonatal patients.\r\n\u2022\tPart 1 \u2013 Highly visual and unique, the gestational age assessment component is based on the Ballard exam. Students will see how to apply different scoring categories by taking a close up look at preterm through term infants.\r\n\u2022\tPart 2 \u2013 The physical exam component is a thorough look at the neonate from head to toe. Both normal and abnormal findings are presented. Numerous photos, illustrations, and videos make difficult concepts easy to understand for all levels of learners.\r\nThe subscription also includes 2 downloadable PDF\u2019s: slide handout and complete physical exam of the newborn worksheet.",
        "learning_objectives_html": "<p>At the conclusion, participants should be able to:<br />\r\n<br />\r\n</p>\r\n<ul>\r\n    <li>Explain how to perform a complete gestational age assessment for preterm through term infants.</li>\r\n    <li>Explain how to perform a thorough infant physical exam from head to toe.</li>\r\n</ul>\r\n<div>&nbsp;</div>\r\n<p>&nbsp;</p>\r\n<div>&nbsp;</div>",
        "course_outline_html": "<ul>\r\n    <li>Slide show</li>\r\n    <li>2 PDF downloads</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "49D1E176-3574-EA11-A221-005056B14D10",
                "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online",
                "is_system_course_category": null
            },
            {
                "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                "course_category_name": "Obstetric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                "course_category_name": "Diagnostic Tests & Examinations",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician (MD/DO)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AFBFC50C-4AFE-11DE-ADE3-0015171C5BB3",
                "course_category_name": "Online CME",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A8BD2E52-FCDD-11DC-AFB4-0015171353BD",
                "course_category_name": "Online CE",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE06D56C-3874-EA11-A221-005056B14D10",
                "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43C3A9F9-E7F9-E611-AF66-005056B104B1",
                "course_category_name": "Neonatal Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "zRemoved-Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF64E5F4-3674-EA11-A221-005056B14D10",
                "course_category_name": "The S.T.A.B.L.E. Program Online",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                "course_category_name": "Infant Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];